import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { DataGrid } from "@material-ui/data-grid";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import ConfirmationDialog from "../common/ConfirmationDialog";
import { hardwaresActions, deleteHardware } from "../../store/hardware-slice";

const columns = [
  { field: "identifier", headerName: "identifier", width: 300 },
  {
    field: "createdTS",
    headerName: "Date created",
    width: 200,
    type: "dateTime",
    valueFormatter: (params) => new Date(params.value).toLocaleString(),
  },
  {
    field: "isAssigned",
    headerName: "Assigned?",
    width: 120,
    type: "boolean",
  },
  { field: "description", headerName: "Description", width: 200 },
];

const useStyles = makeStyles((theme) => ({
  grid: {
    background: "white",
  },
  titleMargin: {
    margin: theme.spacing(1, 0, 4, 0),
  },
}));

const HardwareList = (props) => {
  const dispatch = useDispatch();
  const [isRemove, setIsRemove] = useState(false);
  const classes = useStyles();
  const hardwares = useSelector((state) => state.hardwares.list);
  const selectedHardware = useSelector((state) => state.hardwares.selected);

  const rowSelectedHandler = (event) =>
    dispatch(hardwaresActions.setSelected(event.data.id));

  const deleteHardwareHandler = async () => {
    dispatch(deleteHardware(selectedHardware));
    setIsRemove(false);
  }

  return (
    <>
      <ConfirmationDialog
        open={isRemove}
        onClose={() => setIsRemove(false)}
        onOk={deleteHardwareHandler}
        caption="Please confirm?"
        text="This will delete this hardware identifier completely. Are You sure?"
      />
      <Typography gutterBottom variant="h5" className={classes.titleMargin}>
        Hardware serial numbers
      </Typography>
      <div style={{ height: 200 }}>
        <DataGrid
          className={classes.grid}
          rows={hardwares}
          columns={columns}
          density="compact"
          hideFooter="true"
          selectionModel={props.selected}
          onRowSelected={rowSelectedHandler}
        />
      </div>
      <Grid
        container
        direction="row"
        justify="flex-end"
        alignItems="flex-start"
      >
        <IconButton aria-label="delete" color="primary" onClick={() => setIsRemove(true)} disabled={selectedHardware == null || selectedHardware.isAssigned === true}>
          <DeleteIcon />
        </IconButton>
      </Grid>
    </>
  );
};

export default HardwareList;
